module.exports = __webpack_public_path__ + "img/appstore.5973e05f.png";